import React, { useEffect, useState } from "react";
import {
  CheckBadgeIcon,
  XMarkIcon,
  CreditCardIcon,
} from "@heroicons/react/24/outline";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useReduxStore } from "../hooks/useReduxStore";
import * as paymentService from '../../src/services/paymentService'
import { toast } from "react-toastify";
import { updateAuth } from "../store/Reducers/authReducer";
import { toastConfiguration } from "../Constant/Data";
import { GetAllPaymentMethods } from "../store/Actions/action";
export default function UpgradeConfirmModal({
  show,
  onClose,
  currentPlan,
  newPlan,
  onConfirm,
}) {
  const {getState,dispatch}=useReduxStore()
  const {cards,loading}=getState("AUTH")
  const defaultCard=cards.find(x=>x?.is_default)
  const [selectedCardId, setSelectedCardId] = useState(defaultCard?.id);
  const [addingNewCard, setAddingNewCard] = useState(false);

  const stripe = useStripe();
  const elements = useElements();
 const isDownGrade=currentPlan?.price>newPlan?.price
  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
  }, [show]);
  useEffect(()=>{
    show&&dispatch(GetAllPaymentMethods({stopLoading:true}))
  },[show])
 useEffect(()=>{
if(cards?.length){
  const defaultCard=cards.find(x=>x?.is_default)
  setSelectedCardId(defaultCard?.id)
}
 },[cards])
  if (!show) return null;

  const handleAddCard = async () => {
try {
    dispatch(updateAuth({loading:true}))
     if (elements == null) return;
      let elementError = await elements.submit();
      const { error: submitError } = elementError;
      if (submitError) return;
    const cardE = elements.getElement(CardElement);
    if (!cardE) return;
     
    const { paymentMethod, error } = await stripe.createPaymentMethod(
      {
        type:"card",
          card: cardE,
      }
    );
    if (error) {
     toast.error(error?.message||"Some Thing Went Wrong Please Try Again ",toastConfiguration)
    }
    else{
   let { ok,data,originalError}=await   paymentService?.addUpdateDefaultCard({ paymentMethodId:paymentMethod?.id})
   if(ok){
    toast.success("Your card has been added successfully",toastConfiguration)
     setAddingNewCard(false);
  let arr=  cards.map((c)=>{return({...c, is_default:false})})
        let newCard=makeCard(paymentMethod)
          dispatch(updateAuth({cards:[newCard,...arr,]}))
   }
   else{
 toast.error(data?.message||originalError?.message||"Some Thing Went Wrong Please Try Again",toastConfiguration)
   }
    }
  dispatch(updateAuth({loading:false}))
} catch (error) {
  toast.error("Some Thing Went Wrong Please Try Again ",toastConfiguration)
    dispatch(updateAuth({loading:false}))
  
}
finally{
    dispatch(updateAuth({loading:false}))

}

   
   
  };
const makeCard=(paymentMethod)=>{
  return {
    id:paymentMethod?.id,
    brand:paymentMethod?.brand,
    exp_year:paymentMethod?.card?.exp_year,
    exp_month:paymentMethod?.card?.exp_month,
    last4:paymentMethod?.card?.last4,
    is_default:true
  }
}
const onSelectCard=async(card)=>{
       try {
      
        let {ok,data,originalError} =await paymentService.addUpdateDefaultCard({paymentMethodId:card?.id,stopLoading:false})
        if(ok){
            let arr=  cards.map((c)=>{return({...c, is_default:c.id===card?.id})})
          dispatch(updateAuth({cards:[...arr]}))
        }
        else {
          toast.error(data?.message||originalError?.message||"Some Thing Went Wrong Please Try Again",toastConfiguration)
        }
       } catch (error) {
        toast.error("Some Thing Went Wrong Please Try Again ",toastConfiguration)
       }
}
  return (
    <div className={`fixed inset-0 ${ loading?"z-40":"z-50"} flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm`}>
      <div className="relative w-full max-w-2xl max-h-[95vh] overflow-y-auto bg-white rounded-xl shadow-2xl p-6">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>

        {/* Header */}
        <div className="flex items-center gap-3 mb-5">
          <CheckBadgeIcon className="w-7 h-7 text-green-500" />
          <h2 className="text-xl font-semibold text-gray-800">
           {` Confirm Plan ${isDownGrade?"Downgrade":"Upgrade"}`}
          </h2>
        </div>

        {/* Plan Summary */}
        <div className="mb-6 space-y-2 bg-gray-50 rounded-md p-4 border">
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Current Plan</span>
            <span className="font-medium text-gray-900">
              {currentPlan.name} – ${currentPlan.price}/mo
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">New Plan</span>
            <span className="font-medium text-gray-900">
              {newPlan.name} – ${newPlan.price}/mo
            </span>
          </div>
          <p className="text-xs text-gray-500 pt-2">
            You won’t be charged now. The new plan will start from the next billing date.
          </p>
        </div>

        {/* Cards */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-gray-700 mb-3">Select Payment Method</h3>
          <div className="max-h-48 overflow-y-auto pr-1 space-y-3">
            {cards.map((card) => (
              <label
                key={card.id}
                className={`flex items-center justify-between p-4 rounded-md border cursor-pointer transition 
                ${
                  selectedCardId === card.id && !addingNewCard
                    ? "border-secondary bg-secondary/5"
                    : "border-gray-300 hover:border-secondary/50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <input
                    type="radio"
                    name="card"
                    checked={selectedCardId === card.id && !addingNewCard}
                    onChange={() => {
                       onSelectCard(card)
                      // setSelectedCardId(card.id);
                      setAddingNewCard(false);
                    }}
                    className="accent-secondary"
                  />
                  <CreditCardIcon className="w-5 h-5 text-gray-500" />
                  <span className="text-sm text-gray-700">
                  {card.brand} **** {card.last4} (Exp: {card.exp_month}/{card.exp_year})
                  </span>
                </div>
              </label>
            ))}
          </div>

          {/* Add New Card */}
          <div onClick={()=>{
               setAddingNewCard(!addingNewCard);
          }} className="mt-4">
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
              <input
                type="radio"
                name="card"
                checked={addingNewCard}
                onChange={() => {
                  setAddingNewCard(!addingNewCard);
                  // setSelectedCardId(null);
                }}
                className="accent-secondary"
              />
             <button>
               Add a new card
             </button>
            </label>
          </div>

          {addingNewCard && (
            <div className="mt-4 p-4 rounded-md border bg-gray-50">
              <label className="block text-sm text-gray-600 mb-2">Card Details</label>
              <div className="p-2 border rounded-md bg-white">
                <CardElement
                  options={{
                    style: {
                      base: {
                        fontSize: "14px",
                        color: "#1a202c",
                        "::placeholder": { color: "#a0aec0" },
                      },
                      invalid: { color: "#e53e3e" },
                    },
                  }}
                />
              </div>
              <button
                onClick={handleAddCard}
                className="mt-4 px-8 py-2   bg-secondary text-white text-sm rounded hover:bg-secondary/90"
              >
                Add
              </button>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(addingNewCard ? "new_card" : selectedCardId)}
            className="px-5 py-2 text-sm bg-secondary text-white rounded-md hover:bg-secondary/90 shadow"
          >
            Confirm 
          </button>
        </div>
      </div>
    </div>
  );
}
